import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import swasthiqLogo from "../../assets/swasthiq-logo.png";

interface Props {
  adminEmail?: string;
}

const PlatformAdminNav: React.FC<Props> = ({ adminEmail }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
    } catch {
      // ignore
    }
    navigate("/login", { replace: true });
  };

  return (
    <nav className="bg-[#1A1D23] h-14 flex items-center justify-between px-6 flex-shrink-0">
      <div className="flex items-center gap-2.5">
        <img src={swasthiqLogo} alt="SwasthiQ" className="w-7 h-7 object-contain rounded-lg" />
        <span className="text-white font-semibold text-sm">SwasthiQ</span>
        <span className="text-[#4DA8FF] text-sm font-medium">Platform Admin</span>
      </div>
      <div className="flex items-center gap-3">
        {adminEmail && (
          <span className="text-slate-400 text-xs bg-[#2A2D35] px-3 py-1.5 rounded-lg">
            {adminEmail}
          </span>
        )}
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-slate-400 hover:text-white text-xs px-3 py-1.5 rounded-lg hover:bg-[#2A2D35] transition-colors"
          title="Sign out"
        >
          <svg viewBox="0 0 20 20" className="w-4 h-4 fill-current">
            <path fillRule="evenodd" d="M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z" clipRule="evenodd" />
            <path fillRule="evenodd" d="M6 10a.75.75 0 01.75-.75h9.546l-1.048-.943a.75.75 0 111.004-1.114l2.5 2.25a.75.75 0 010 1.114l-2.5 2.25a.75.75 0 11-1.004-1.114l1.048-.943H6.75A.75.75 0 016 10z" clipRule="evenodd" />
          </svg>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default PlatformAdminNav;
